import { render, staticRenderFns } from "./app.vue?vue&type=template&id=15c716f1&scoped=true&lang=pug"
import script from "./app.js?vue&type=script&lang=js&external"
export * from "./app.js?vue&type=script&lang=js&external"
import style0 from "./app.vue?vue&type=style&index=0&id=15c716f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c716f1",
  null
  
)

export default component.exports